// 9fbef606107a605d69c0edbcd8029e5d
import constants from './CarouselTab.constants';

const initialState = {};

const CarouselTabReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case constants.CAROUSEL_TAB_REQ: {
      const { categoryId } = payload;
      const name = categoryId?.toLowerCase()?.split(' ')?.join('');
      return { ...state, completed: { ...state.completed, [name]: true } };
    }
    case constants.CAROUSEL_TAB_SUCCESS:
    case constants.CAROUSEL_TAB_FAIL:
      return {
        ...state,
        ...payload,
        errors: { ...state.errors, ...payload.errors },
        completed: { ...state.completed, ...payload.completed },
      };
    default:
      return state;
  }
};

export default CarouselTabReducer;
